import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreProjectBookmarksModule } from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { ProjectBookmarkButtonComponent } from './project-bookmark-button.component';

@NgModule({
  imports: [CommonModule, DatastoreProjectBookmarksModule, UiModule],
  declarations: [ProjectBookmarkButtonComponent],
  exports: [ProjectBookmarkButtonComponent],
})
export class ProjectBookmarkButtonModule {}
